import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { FormControl } from '@angular/forms'
import { OptionConfig } from '@app-domains/ui/components/select/select.component.types'

@Component({
    selector: 'app-select-optgroup',
    templateUrl: './select-optgroup.component.html',
    styleUrls: ['./select-optgroup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SelectOptgroupComponent {
    @Input()
    public control: FormControl

    @Input()
    public label: string

    @Input()
    public options: OptionConfig[]

    @Output()
    public valueUpdated = new EventEmitter<string>()
}
